export default function Section15() {
    const industries = [
        {
            title: "Retail & Fashion",
            text: "High-performing ecommerce websites designed to boost sales, improve user experience, and strengthen brand identity.",
            icon: "🛍️",
        },
        {
            title: "Tech Startups",
            text: "Scalable web platforms and applications built to support rapid growth, innovation, and product expansion.",
            icon: "🧠",
        },
        {
            title: "Healthcare",
            text: "Secure and compliant healthcare websites with a focus on data protection, accessibility, and patient engagement.",
            icon: "🏥",
        },
        {
            title: "Real Estate & Enterprises",
            text: "Advanced web portals that connect buyers, sellers, and teams with smooth navigation and efficient workflows.",
            icon: "🏢",
        },
        {
            title: "SaaS & Digital Platforms",
            text: "Robust SaaS solutions and web applications designed for scalability, performance, and seamless user experience.",
            icon: "📱",
        },
    ];

    return (
        <div className="Section15 my-[-20px] md:my-[10px] md:py-[30px] bg-gray-100">
            {/* Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Industries We Serve
                </h2>
                                <p className="mt-2 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    At Mean3, we deliver tailored web development solutions for a wide range of industries. Our experience allows us to understand unique business challenges and build platforms that drive real results.</p>
            </div>

            {/* Industries Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
                {industries.map((industry, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300 p-6 rounded-2xl shadow-md bg-[#f5f5f5]"
                    >
                        {/* Icon */}
                        <div className="text-4xl md:text-5xl mb-4">{industry.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                            {industry.title}
                        </h3>

                        {/* Description */}
                        <p className="text-gray-600 text-sm md:text-base">{industry.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

